/**
 * Default UI labels for sidebar components.
 * Consumers can override by providing custom labels via inputs.
 */
export const sidebarLabels = {
  // Filter sidebar
  filterTitle: () => $localize`:@@sidebar.filter.title:Filter`,
  filterReset: () => $localize`:@@sidebar.filter.reset:Zurücksetzen`,
  filterApply: () => $localize`:@@sidebar.filter.apply:Anwenden`,
  filterClose: () => $localize`:@@sidebar.filter.close:Schließen`,
} as const;
